import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteApiGatewayKeyByIdRequest = {
	apiKeyId: number;
};

export const deleteApiGatewayKeyById = createDeleteEndpoint<DeleteApiGatewayKeyByIdRequest>(
	({ apiKeyId }) => `/api/v3/security/api-gateway-keys/${apiKeyId}`
);
